import React from 'react';
import { CatalogIcon, DocsIcon } from '@backstage/core-components';
import Assignment from '@material-ui/icons/Assignment';

export const searchTypes = [
  {
    value: 'software-catalog',
    name: 'Software Catalog',
    icon: React.createElement(CatalogIcon),
  },
  {
    value: 'techdocs',
    name: 'Documentation',
    icon: React.createElement(DocsIcon),
  },
  {
    value: 'task-snippets',
    name: 'Task',
    icon: React.createElement(Assignment),
  },
  {
    value: 'adr',
    name: 'Architecture Decision Records',
    icon: React.createElement(DocsIcon),
  },
];
